import axios from "axios";

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  return "http://localhost:8000/api";
};

const api = axios.create({
  baseURL: window.CARLOCA_API || getBaseURL(),
});

api.interceptors.request.use(
  (config) => {
    try {
      const serializedData = localStorage.getItem("userData");
      if (serializedData) {
        const userData = JSON.parse(serializedData);

        if (userData && userData.token) {
          config.headers.Authorization = `Bearer ${userData.token}`;
        }
      }
    } catch (error) {
      console.error("Error fetching token from local storage", error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
